import { observable } from 'mobx';
import BaseModalStore from '../layout/base-store';

class MechaInfoModalStore extends BaseModalStore {
  name = '机体档案弹窗';

  @observable mechaInfo = null;

  use() {
    super.use();
  }
}

export default MechaInfoModalStore;
